<template>
  <div class="analysis-list">
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float" @submit.prevent>
        <div class="form-group">
          <label for="a_name">物业：</label>
          <el-select
            class="check-property"
            filterable
            clearable
            v-model.trim="search.propertyId"
          >
            <el-option
              v-for="item in propertyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="form-group other">
          <span class="search_btn">
            <el-button
              @click="searchList"
              type="primary"
              :loading="loading"
               size="small"
            >
              查询
            </el-button>
          </span>
        </div>
      </form>
    </div>
    <div class="configure-right">
      <div class="actual_status">
        <div class="backdrop" style="background-color: rgb(238, 174, 68)">
          <div class="task">
            <div class="text">
              <img src="@/assets/images/task-1.png" />
            </div>
            <div class="num">
              <div>车场数量</div>
              <div>
                {{
                 Number(parkingData.roadNum)+Number(parkingData.onsiteNum)
                   
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="backdrop" style="background-color: rgb(43, 169, 227)">
          <div class="task">
            <div class="text">
              <img src="@/assets/images/task-2.png" />
            </div>
            <div class="num">
              <div>应收总额(元)</div>
              <div>
                {{
                  tableListData.receivable
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="backdrop" style="background-color: rgb(231, 25, 27)">
          <div class="task">
            <div class="text">
              <img src="@/assets/images/task-4.png" />
            </div>
            <div class="num">
              <div>实收总额(元)</div>
              <div>
                {{
                  tableListData.realMoney
                   
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="backdrop" style="background-color: #24d4d6">
          <div class="task">
            <div class="text">
              <img src="@/assets/images/dataAnalysis/zhuijiao.png" />
            </div>
            <div class="num">
              <div>欠费追缴总额(元)</div>
              <div>
                {{
                  tableListData.arrearsMoney
       
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="backdrop" style="background-color: rgb(192, 127, 231)">
          <div class="task">
            <div class="text">
              <span
                ><img src="@/assets/images/dataAnalysis/qianfeijine.png"
              /></span>
            </div>
            <div class="num">
              <div>欠费总额(元)</div>
              <div>
                {{ tableListData.unpayMoney }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="charts">
        <div class="charge-search">
          <el-date-picker
            v-model="daterange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="false"
          >
          </el-date-picker>
          <el-button type="primary" :loading="status" @click="renderChart"
            >搜索</el-button
          >
          <span class="mark">注：请选择30天内的时间段</span>
        </div>

        <div id="myChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
  chargeChartList,
  statistics,
  analyse,
  fetchPropertyList,
  getGroupDayReportList,
  homeParkingDatas,
  homeMoneyDatas
} from "@/api/url";
import Page from "../../commons/page";
import AreaTree from "../../commons/areaTree";
const dayjs = require("dayjs");
export default {
  filters: {},
  data() {
    return {
      daterange: [dayjs().subtract(30, "day"), dayjs().subtract(1,"day")],
      isShow: false,
      status: false,
      search: {
        propertyId: null,
      },
      propertyList: [],
      myChart: {
        title: {
          text: "每天收费统计",
          subtext: "近30天",
          x: "center",
          align: "right",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: [{ left: "4%", top: "10%", width: "90%", height: "75%" }],

        legend: {
          data: ["支付宝", "微信", "现金", "总和", "欠费"],
          orient: "horizontal",
          top: "bottom",
          bottom: "20%",
        },

        xAxis: [
          {
            name: "时间",
            splitLine: { show: true },
            axisLabel: {
              interval: 0,
              rotate: 20,
              color: "#333333",
            },
            axisLine: {
              lineStyle: { color: "#4488BB", width: 2 },
            },
            splitLine: { show: true },
            type: "category",
            data: [], //时间
          },
        ],
        yAxis: [{}, {}],
        series: [
          {
            name: "支付宝",
            type: "bar",
            data: [],
          },
          {
            name: "微信",
            type: "bar",
            data: [],
          },
          {
            name: "现金",
            type: "bar",
            data: [],
          },
          {
            name: "总和",
            type: "line",
            data: [],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#5dacff",
                    fontSize: 12,
                  },
                },
              },
            },
            smooth: true,
          },
          {
            name: "欠费",
            type: "line",
            data: [],

            smooth: true,
          },
        ],
      },

      tableListData: {},
      parkingData:{},
      moduleName: "parking",
      loading: false,
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    formatData: function(value) {
      if (!value) return "";
      return parseInt(value)
        .toString()
        .replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,");
    },
   
    statistics: function() {
      return Promise.all([
        this.$get(homeMoneyDatas(), {
          // companyId: this.search.propertyId,
        }).then((data) => {
          if (data.status != 200) return;
          this.tableListData = data.data;
        }),
        this.$get(homeParkingDatas(),{}).then(data=>{
          if (data.status != 200) return;
          this.parkingData = data.data;
        })
      ]);
    },
    async searchList() {
      this.loading = true;
      try {
        await this.renderChart();
        await this.statistics();
      } finally {
        this.loading = false;
      }
    },
    getAllProperty() {
      return this.$get(fetchPropertyList()).then((data) => {
        if (data.status === 200) {
          this.propertyList = data.data;
        }
      });
    },
    async initProperty() {
      await this.getAllProperty();
      this.search.propertyId = this.propertyList[0].id;
      this.renderChart();
      this.statistics();
    },
    async renderChart() {
      if (this.daterange.length < 2) return;
      if (dayjs(this.daterange[1]).diff(dayjs(this.daterange[0]), "day") > 30) {
        this.$message({
          message: "时间段为30天内",
          type: "warning",
        });
        return;
      }
      this.status = true;
      await this.reqGroupDayReportList();
      let myChart = this.$echarts.init(document.querySelector("#myChart"));
      window.addEventListener("resize",()=>{
        myChart.resize()
      })
      this.$nextTick(function() {
        myChart.setOption(this.myChart, true);
      });
      this.status = false;
    },
    reqGroupDayReportList() {
      const params = {
        groupId: this.search.propertyId,
        beginTime: dayjs(this.daterange[0]).format("YYYY-MM-DD"),
        endTime: dayjs(this.daterange[1]).format("YYYY-MM-DD"),
        page: 1,
        limit: 30,
      };
      return this.$get(getGroupDayReportList(), { ...params }).then((data) => {
        this.myChart.series[0].data = [];
        this.myChart.series[1].data = [];
        this.myChart.series[2].data = [];
        this.myChart.series[3].data = [];
        this.myChart.series[4].data = [];
        this.myChart.xAxis[0].data = [];
        if (data.status != 200) return;
        for (let i=data.data.rows.length-1;i>=0;i--) {
          this.myChart.series[0].data.push(data.data.rows[i].alipay);
          this.myChart.series[1].data.push(data.data.rows[i].wechat);
          this.myChart.series[2].data.push(data.data.rows[i].cash);
          this.myChart.series[3].data.push(data.data.rows[i].real_money);
          this.myChart.series[4].data.push(data.data.rows[i].unpay);
          this.myChart.xAxis[0].data.push(data.data.rows[i].date);
        }
      });
    },
  },
  created: function() {},
  mounted: function() {
    this.initProperty();
  },
  components: {
    AreaTree,
  },
};
</script>

<style lang="scss">
.analysis-list {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .actual_status {
    height: 150hpx;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .backdrop {
    width: 20%;
    height: 100%;
    margin: 5hpx 20wpx;
    padding: 30hpx 20wpx;
    border-radius: 10px;
    box-sizing: border-box;
  }
  .task {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .num {
      padding-left: 20wpx;
      color: white;
      div:first-child {
        font-size: 16px;
        font-weight: bold;
      }
      div:last-child {
        font-size: 24px;
        font-weight: bold;
      }
    }
  }
  #myChart {
    height: 80%;
    width: 100%;
    box-sizing: border-box;
    padding-top: 20hpx;
    padding-left: 20wpx;
  }
  #parkmyChart {
    padding-top: 20px;
    padding-left: 2%;
  }
  img {
  }
  .configure-right {
    width: 100%;
    height: calc(100% - 90hpx);
  }
  .noData {
    text-align: center;
    position: relative; /*脱离文档流*/
    top: 50%; /*偏移*/
  }
  .charge-search {
    .el-date-editor {
      width: 20% !important;
      max-width: 20% !important;
      height: 45hpx;

      margin: 20hpx 10wpx 20hpx 20wpx;
    }
  }

  .charts {
    height: calc(100% - 150hpx);
    padding-top: 20hpx;
    box-sizing: border-box;
  }
  .mark {
    color: red;
    margin-left: 20wpx;
  }
}
</style>
